import { useHistory } from 'react-router-dom';

import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { routes } from '@/router';
import {
  AuthEnterpriseService,
  ManagerAccountCreateForm,
} from '@/services/AuthEnterprise';

export const useManagerAccountCreate = (): ((
  email: string,
  name: string,
  role_type: string,
  auth_store_names: string[]
) => Promise<void>) => {
  const authEnterpriseService = new AuthEnterpriseService(getClient());
  const history = useHistory();

  const managerAccountCreate = async (
    email: string,
    name: string,
    role_type: string,
    auth_store_names: string[]
  ) => {
    const body: ManagerAccountCreateForm = {
      email,
      name,
      role_type,
      auth_store_names,
    };
    return await authEnterpriseService
      .create(body)
      .then(() => {
        alert('招待メールを送信しました');
        history.push(routes.SettingsMemberManagement.path);
      })
      .catch((error: Error) => errorHandler({ error }));
  };

  return managerAccountCreate;
};
